const HEADLINER_USER_V1_PATH = '/api/v1/headliner-user';
const HEADLINER_USER_V2_PATH = '/api/v2/headliner-user';

export const PERSONAL_FONTS_PATH = `${HEADLINER_USER_V1_PATH}/personal-fonts`;
export const MY_PERSONAL_FONTS_PATH = `${PERSONAL_FONTS_PATH}/me`;
export const MY_GOOGLE_FONTS_PATH = `${HEADLINER_USER_V1_PATH}/google-fonts`;
export const PERSONAL_FONT_PATH = `${PERSONAL_FONTS_PATH}/:fontId`;

export const SUPPORT_REQUEST_PATH = `${HEADLINER_USER_V1_PATH}/support/support-request`;

export const DISPLAY_PREFS_PATH = `${HEADLINER_USER_V2_PATH}/display-pref`;
export const USER_DISPALY_PREFS_PATH = `${DISPLAY_PREFS_PATH}/:userId`;
export const MY_DISPLAY_PREFS_PATH = `${DISPLAY_PREFS_PATH}/me`;

export const USER_PREFS_PATH = `${HEADLINER_USER_V1_PATH}/user-pref`;
export const MY_USER_PREFS_PATH = `${USER_PREFS_PATH}/me`;
export const MY_CAPTIONS_PREFS_PATH = `${USER_PREFS_PATH}/captions/me`;
export const MY_VIDEO_EXPORT_PREFS_PATH = `${USER_PREFS_PATH}/video-export/me`;
export const MY_COLOR_PREFS_PATH = `${USER_PREFS_PATH}/colors/me`;
export const WAVEFORM_PREFERENCES_PATH = `${USER_PREFS_PATH}/waveform`;
export const WAVEFORM_PREFERENCE_PATH = `${USER_PREFS_PATH}/waveform/:waveformPrefId`;
export const VIDEO_SIZES_PATH = `${USER_PREFS_PATH}/video-sizes`;

export const MEDIA_LIBRARY_PATH = `${HEADLINER_USER_V1_PATH}/media-library`;
export const SAMPLE_AUDIO_PATH = `${MEDIA_LIBRARY_PATH}/sample-audio`;

export const ANNOUNCEMENTS_PATH = `${HEADLINER_USER_V1_PATH}/announcement`;
export const MY_ANNOUNCEMENTS_PATH = `${ANNOUNCEMENTS_PATH}/me`;
export const ANNOUNCEMENT_VIEW_CONFIRMATION_PATH = `${ANNOUNCEMENTS_PATH}/view-confirmation`;

export const ONBOARDING_PATH = `${HEADLINER_USER_V1_PATH}/onboarding`;
export const MY_ONBOARDING_PATH = `${ONBOARDING_PATH}/me`;
export const ONBOARDING_VIEW_CONFIRMATION_PATH = `${ONBOARDING_PATH}/view-confirmation`;

export const PROJECT_TEMPLATES_PATH = `${HEADLINER_USER_V1_PATH}/project-templates`;
export const PROJECT_TEMPLATE_PATH = `${PROJECT_TEMPLATES_PATH}/:templateId`;
export const PROJECT_TEMPLATE_COMPATIBILITY_PATH = `${PROJECT_TEMPLATES_PATH}/widget-config/:configurationId/compatibility`;
export const PROJECT_UST_COMPATIBILITY_PATH = `${PROJECT_TEMPLATES_PATH}/:templateId/compatibility`;

export const QUESTIONNAIRE_PATH = `${HEADLINER_USER_V1_PATH}/questionaire`;
export const QUESTIONNAIRE_RESPONSE_PATH = `${QUESTIONNAIRE_PATH}/response`;
export const MY_QUESTIONNAIRE_RESPONSE_PATH = `${QUESTIONNAIRE_RESPONSE_PATH}/me`;
export const MY_QUESTIONNAIRE_STATUS_PATH = `${QUESTIONNAIRE_PATH}/status/me`;

export const LANGUAGE_PATH = `${HEADLINER_USER_V1_PATH}/language`;
export const EDDY_LANGUAGES_PATH = `${LANGUAGE_PATH}/eddy-project`;
export const MAKE_AUTOMATION_LANGUAGES_PATH = `${LANGUAGE_PATH}/make-automation`;
export const MAKE_CAPTION_LANGUAGES_PATH = `${LANGUAGE_PATH}/make-caption`;

export const EXPERIMENTS_PATH = `${HEADLINER_USER_V1_PATH}/experiments`;
export const MY_ACTIVE_EXPERIMENT_VARIANTS_PATH = `${EXPERIMENTS_PATH}/variants/me`;

export const TEXT_PRESETS_PATH = `${HEADLINER_USER_V1_PATH}/text-preset`;
export const MY_TEXT_PRESETS_PATH = `${TEXT_PRESETS_PATH}/me`;
export const MY_TEXT_PRESET_PATH = `${MY_TEXT_PRESETS_PATH}/:textPresetId`;

export const NOTIFICATION_ALERT_PATH = `${HEADLINER_USER_V1_PATH}/notification-alert`;
export const MY_NOTIFICATION_ALERT_PATH = `${NOTIFICATION_ALERT_PATH}/me`;
